import Immutable from 'immutable';
import _ from 'underscore';
import validate from 'validate.js';
import Validators from 'lib/validators';
import { stripeFieldErrors, stripeFields } from 'lib/form/stripe_fields';

const FormValidation = {
  isValid(section) {
    _.extend(validate.validators, Validators);

    let errors;
    if (section === undefined) {
      errors = validate(this.state.fields.toJS(), this.validationConstraints());
    } else {
      errors = validate(
        this._sectionFields(section),
        this._sectionValidations(section)
      );
    }

    const stripeValidationRequired = () => {
      if (this.props.mobile) {
        return (
          this.state.activeScreen.get('component') ==
            'Views.Plugins.Checkout.Mobile.Screens.CheckoutPayment' &&
          !!this.validationConstraints().cardNumber
        );
      }
      return !!this.validationConstraints().stripe;
    };

    if (stripeValidationRequired() && !this.state.stripe?.token) {
      const { isPayLaterSelected } = this.state;
      const stripeErrorsObject = {};
      stripeFields.forEach((field) => {
        const hasStripe =
          this.state.stripe && this.state.stripe.fieldsCompleted;

        if (
          !isPayLaterSelected &&
          hasStripe &&
          !this.state.stripe.fieldsCompleted.includes(field)
        ) {
          stripeErrorsObject[field] = stripeFieldErrors[field];
        }
      });
      errors = { ...errors, ...stripeErrorsObject };
    }

    if (!_.isEmpty(errors)) {
      this.setState({
        errors: Immutable.Map(errors),
      });

      if (typeof this.onValidationErrors === 'function') {
        this.onValidationErrors(errors);
      }

      return false;
    }
    return true;
  },
};

export default FormValidation;
